import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import useNavigationBlocker from "../../../../../../hooks/navigation-blocker-hook";
import EditorPageLayout from "../../../../../../components/layouts/editor-page/editor-page-layout";
import ListLayout from "../../../../../../components/layouts/list-layout/list-layout";
import ControlGroupWithPreview from "../../../../../../components/layouts/control-group-with-preview/control-group-with-preview";
import LocateShipmentPreview from '../../../../../../images/previews/locate-shipment.svg';
import LocateShipmentMessagesPreview from '../../../../../../images/previews/locate-shipment-messages.svg';
import { FormField } from "../../../../../../components/form-field/form-field";
import TranslationRichTextEditor from "../../../../../../translation/translation-rich-text-editor/translation-rich-text-editor";
import { TRACKING_PORTAL_TRANSLATION_KEYS } from "../../constants";
import TranslationTextarea from "../../../../../../translation/translation-textarea/translation-textarea";
import TranslationInput from "../../../../../../translation/translation-input/translation-input";
import { ConfirmModal } from "../../../../../../components/modal/components/confirm-modal/confirm-modal";

const LocateShipmentEditor: React.FC = observer(() => {
    const [isShowUnsaved, setIsShowUnsaved] = useState(false);

    const {
        hasChanges: hasTranslationChanges,
        discardChanges: translationsDiscardChanges,
        save: saveTranslations
    } = useTranslation();

    const hasChanges = () => {
        return hasTranslationChanges();
    }

    const { retryNavigation, unblockNavigation } = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    const discardChanges = () => {
        translationsDiscardChanges();
    }

    const onSaveClicked = () => {
        const promised = [];

        if (hasTranslationChanges()) {
            promised.push(
                saveTranslations()
            );
        }

        Promise.all(promised).then(() => {
            unblockNavigation();
        })
    }


    return (
        <>
            <EditorPageLayout
                toolbar={{
                    saveButton: {
                        hasChanges: hasChanges(),
                        disabled: !hasChanges(),
                        onClick: onSaveClicked
                    }
                }}
            >

                <ListLayout>
                    <ControlGroupWithPreview
                        hasTopBorder={false}
                        preview={<img src={LocateShipmentPreview} alt="" />}
                    >
                        <ListLayout>
                            <FormField label="Header">
                                <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.TRACKING_PORTAL_TITLE} />
                            </FormField>
                            <FormField label="Instructions">
                                <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.LETS_TRACK_ORDER} />
                            </FormField>
                            <FormField label="Locate Shipment Instructions">
                                <TranslationRichTextEditor minHeight={250} translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.FIRST_PAGE_TRACKING_CONTENT} />
                            </FormField>
                        </ListLayout>
                    </ControlGroupWithPreview>

                    <ControlGroupWithPreview
                        preview={<img src={LocateShipmentMessagesPreview} alt="" />}
                    >
                        <ListLayout>
                            <FormField
                                label="Error Message: No Results"
                            >
                                <TranslationTextarea translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.NO_RESULTS} />
                            </FormField>

                            <FormField
                                label="General Error Message"
                            >
                                <TranslationTextarea translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.GENERAL_ERROR_MESSAGE} />
                            </FormField>

                            <FormField
                                label="Search Error Message"
                            >
                                <TranslationInput translationKey={TRACKING_PORTAL_TRANSLATION_KEYS.SEARCH_ERROR} />
                            </FormField>

                        </ListLayout>
                    </ControlGroupWithPreview>
                </ListLayout>
            </EditorPageLayout>

            {isShowUnsaved &&
                <ConfirmModal
                    cancelButton={{
                        title: 'Cancel',
                        onClick: () => setIsShowUnsaved(false)
                    }}
                    okButton={{
                        title: 'Discard',
                        onClick: () => {
                            discardChanges();
                            setIsShowUnsaved(false);
                            retryNavigation();
                        }
                    }}
                />
            }
        </>
    );
});

export default LocateShipmentEditor;